import { ConfigProvider } from 'antd';
import React, { FC, useMemo } from 'react';
import ltLT from 'antd/lib/locale/lt_LT';
import enUS from 'antd/lib/locale/en_US';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

interface IProps {}

const ConfigProviderWrapper: FC<IProps> = ({ children }) => {
  const { i18n, t } = useTranslation();

  const locale = useMemo(() => {
    if (i18n.language === 'en-US') {
      moment.locale('en');
      return enUS;
    }
    moment.locale('lt');
    return ltLT;
  }, [i18n.language]);

  const validateMessages = {
    required: t('Auth.Login.ThisFieldIsRequired', 'This field is required'),
    whitespace: t(
      'Auth.Login.FieldCannotBeBlank',
      'This field cannot be blank',
    ),
  };
  return (
    <ConfigProvider form={{ validateMessages }} locale={locale}>
      {children}
    </ConfigProvider>
  );
};

export default ConfigProviderWrapper;
